
import { AnyAaaaRecord } from 'dns';
import { useEffect, useMemo, useState } from 'react';
import styles from './index.less';
let weekDays: any  = [];
function ScheduleTable(props: { data?: any; sliceCount?: number }) {
  const { data, sliceCount = 2 } = props;
  const x_dayPeriod = useMemo(() => {
    return data?.weekDesc;
  }, [data]);

  // 根据今天日期计算  一周的日期
  useEffect(() => {
  getDates()
    }, []);
  //   
  const getDates = () => {
    var new_Date = new Date()
    var timesStamp = new_Date.getTime();
    var currenDay = new_Date.getDay();
    for (let i = 0; i<7; i++) {
      const day = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7));
      const wkDate =  day.getMonth()+'/'+day.getDate();
      weekDays.push(wkDate);
    }
  }  

  const [hide, setHide] = useState(false);

  const y_weeks = useMemo(() => {
    return data?.currentDayPeriodDesc; 
  }, [data]);

  const duty = useMemo(() => {
    if (!x_dayPeriod?.length || !y_weeks?.length) {
      return undefined;
    }

    const dutyList = data?.dutyList;

    if (!dutyList) {
      return undefined;
    }

    const arr: any = [];

    y_weeks.forEach((y:any) => {
      const _arr: any = [];
      x_dayPeriod.forEach((x:any) => {
        const k = `${x.type || null}-${y.type || null}`;
        // console.log(k, dutyList);
        const v = dutyList[k];
        _arr.push(v);
      });
      arr.push(_arr);
    });

    return arr;
  }, [x_dayPeriod, y_weeks, data?.dutyList]);

  return (
    <div className={styles.box}>
      <div className={styles.titleBar}>
        {!!x_dayPeriod?.length && <div className={styles.titleItem} />}
        {x_dayPeriod?.map((item:any, idx:any) => {
          return (
            <div key={idx} className={styles.titleItem}>
              <div>{item.desc}</div>
              <div className={styles.weekDays}>{weekDays[idx]}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.contentBox}>
        {duty?.map((ditem: any, idx: any) => {
          const wk = y_weeks?.[idx];
          return (
            <div
              key={wk?.desc}
              className={`${styles.dutyBoxItem} ${hide && idx + 1 > sliceCount ? styles.hide : ''}`}
            >
              <div className={styles.weekItem}>{wk?.desc}</div>
              <div className={styles.dutyList}>
                {ditem.map((item:any, idx2:any) => {
                  return (
                    <div
                      key={idx2}
                      className={`${styles.dutyItem}  ${!!item ? styles.hasval : ''} ${
                        item?.registerType === 2 ? styles.texu : ''
                      }`}
                    >
                      {!!item && (
                        <>
                          <div className={styles.textTop}>
                            <div className={styles.registerName}>{item.registerName}</div>
                            <div className={styles.diagPrice}>
                              <span>¥</span> 
                              {item.diagPrice}</div>
                            <div className={styles.diagAddress}>{item.diagAddress}</div>
                           </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {/* <div
        className={styles.showAll}
        onClick={() => {
          setHide(!hide);
        }}
      >
        <span>收起</span>
        <span className={`${styles.showIcon} ${hide ? '' : styles.hideIcon}`} />
      </div> */}
    </div>
  );
}

export default ScheduleTable;
